// extracted by mini-css-extract-plugin
module.exports = {"container":"ServiceLinks_container__eM_I5","link":"ServiceLinks_link__PvW0Y"};